import React from "react";
import { Popover } from "antd";
import KEFU from "@/assets/images/kefu.png";
import WEIXIN from "@/assets/images/weixin.png";
// import QR_KF from "@/assets/images/qr_kf.png";
// import QR_WX from "@/assets/images/qr_wx.jpg";

import './index.scss';

const QR_KF = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/1.png'
const QR_WX = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/2.jpg'

const Link: React.FC = () => {
  return (
    <div className="out-float">
        {/* <div className="out-float-item"> */}
        <Popover
            getPopupContainer={(trigger: any) => trigger.parentElement}
            content={
                <div className="out-float-kf">
                <img style={{ width: '160px', height: '160px'}} src={QR_KF} />
                <div className="out-float-kf-title" style={{ marginTop: '12px' }}>
                    <span>联系我们</span>
                </div>
                <div className="out-float-kf-des" style={{ marginTop: '4px' }}>
                    <span>扫码添加官方客服</span>
                </div>
                </div>
            }
            placement="leftBottom"
            // color="#2B303B"
            >
            <img style={{ width: '48px', height: '48px', borderRadius: '24px', backdropFilter: 'blur(10px)' }} src={KEFU} />
        </Popover>
        {/* </div> */}
        
        <Popover
            getPopupContainer={(trigger: any) => trigger.parentElement}
            content={
                <div className="out-float-kf">
                <img style={{ width: '160px', height: '160px'}} src={QR_WX} />
                <div className="out-float-kf-title" style={{ marginTop: '12px' }}>
                    <span>关注我们</span>
                </div>
                <div className="out-float-kf-des" style={{ marginTop: '4px' }}>
                    <span>扫码关注森宇宙好绘AI公众号</span>
                </div>
                </div>
            }
            placement="leftBottom"
            // color="#2B303B"
            >
            <img style={{ width: '48px', height: '48px', borderRadius: '24px', backdropFilter: 'blur(10px)' }} src={WEIXIN} />
        </Popover>
    </div>
  );
};

export default Link;
